import Vue from 'vue'
import Router from 'vue-router'
import HomePage from '@/components/HomePage'
import Faqs from '@/components/Faqs'
import Form from '@/components/Form'
import PayAccepted from '@/components/payAccepted'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'HomePage',
      component: HomePage
    },
    {
      path: '/faqs',
      name: 'faqs',
      component: Faqs
    },
    {
      path: '/form',
      name: 'form',
      component: Form
    },
    {
      path: '/payAccepted',
      name: 'payAccepted',
      component: PayAccepted
    },
  ]
  
})



// WEBPACK FOOTER //
// ./src/router/index.js